import { createContext, useContext, useEffect, useReducer } from 'react';
import ajaxSchool from '../util/remote/ajaxSchool';

const initialState = { 
    paymentList: null,
    metaData: null,
    currentPage: 1,
    mounted: false,
    searchText: "",
    openingDate: null,
    closingDate: null,
    status: "all",
    selectedIds: [],
};

const reducer = (state, action) => {
  switch (action.type) {
    case 'CLEAR':
      return { initialState};  // Reset state completely
    default:
      return {...state, [action.type]: action.payload};
  }
};



const OnlineSchoolFeesContext = createContext();

export const OnlineSchoolFeesProvider = ({children}) =>{
  const [state, dispatch] = useReducer(reducer, initialState);

  useEffect(()=>{
    if(state.mounted){
      getTransactions(true);
    }
  }, [state.currentPage]);

 
 
  const getTransactions = async(refresh)=>{
    dispatch({ type: 'mounted', payload: true });
    if(!refresh && Array.isArray(state.paymentList)){
      return;
    }
    dispatch({ type: 'paymentList', payload: null });
    const data = {
      page: state.currentPage,
      opening_date: state.openingDate,
      closing_date: state.closingDate,
      status: state.status,
      search_text: state.searchText,
    };
    const server_response = await ajaxSchool.fetchOnlineFeesPayment(data);
    if(server_response.status==="OK"){
      dispatch({ type: 'paymentList', payload: server_response.details.data });
      dispatch({ type: 'metaData', payload: server_response.details.meta });
    }else{
      dispatch({ type: 'paymentList', payload: "404" });
      dispatch({ type: 'metaData', payload: "404" });

    }
  }

  const setCurrentPage = (page)=>{
    dispatch({ type: 'currentPage', payload: page });
  }

  const refresh = async() =>{
      await  getTransactions(true);
  }

  const setSelectedIds = (ids)=>{
    dispatch({ type: 'selectedIds', payload: ids });
  }

  return(
    <OnlineSchoolFeesContext.Provider value={{
      ...state, 
      dispatch, 
      getTransactions,
      setCurrentPage,
      refresh,
      setSelectedIds
      }}>
      {children}
    </OnlineSchoolFeesContext.Provider>
  )

}

export const useOnlineSchoolFees = ()=>useContext(OnlineSchoolFeesContext);

